import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import './LeadTag.styles.scss';

type LeadTagProps = {
  className?: string;
  isWithdraw?: boolean;
};

const LeadTag: React.FC<LeadTagProps> = (props) => {
  const { className, isWithdraw = false } = props;

  const classes = classNames('lead-tag', { red: isWithdraw }, className);

  const { t } = useTranslation();

  return (
    <span className={classes}>{t(isWithdraw ? 'withdrawn' : 'lead')}</span>
  );
};

export default LeadTag;
